/* eslint-disable prettier/prettier */

export const getProfileCalibrationsByConfig = /* GraphQL */ `
  query ProfileCalibrationsByConfig(
    $calibrationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProfileCalibrationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getOrgLoopPSConfigurations(id: $calibrationId) {
      calibrations(
        filter: $filter
        limit: $limit
        nextToken: $nextToken
        sortDirection: $sortDirection
      ) {
        items {
          createdAt
          profile {
            activeOrg
            alias
            createdAt
            email
            id
            level
            manager
            name
            preferredTimezoneId
            status
            title
            updatedAt
          }
          status
          updatedAt
        }
        nextToken
      }
      org {
        id
        name
      }
    }
  }
`;

export const getProfilePreferences = /* GraphQL */`
  query GetProfilePreferences($id: ID!) {
    getProfile(id: $id) {
      id
      alias
      name
      email
      level
      br
      brit
      status
      loopInterest
      phoneScreenInterest
      brInterest
      diversityInterviewer
      notifyWeeklyDigest
      notifyLoopOpportunity
      notifyPhoneScreenOpportunity
      preferredTimezoneId
      activeOrg
      createdAt
      updatedAt
    }
  }
`;

export const listProfileAvailabilities = /* GraphQL */ `
  query listProfileAvailabilities(
    $id: ID!
  ) {
    getProfile(id: $id) {
      alias
      availabilities(filter: { expired: { eq: false } }, limit: 1000) {
        items {
          availabilityClose
          availabilityDate
          availabilityOpen
          availabilitySeriesID
          createdAt
          id
          recurringEndDate
          recursion
          rrule
          sendCalendarInvite
          state
          updatedAt
        }
        nextToken
      }
      brStatus
      calibrations(filter: { status: { eq: CALIBRATED } }, limit: 100) {
        items {
          calibrationId
          calibration {
            configType
            id
            orgID
          }
          independentCount
          reverseShadowCount
          reviewCount
          shadowCount
          status
          updatedAt
        }
      }
      email
      id
      status
      level
      manager
      name
      preferredTimezoneId
      status
    }
  }
`;

export const getProfileOrgV2 = /* GraphQL */ `
  query GetProfileOrganizationV2($profileID: ID!, $orgID: ID!) {
    getProfileOrganizationV2(profileID: $profileID, orgID: $orgID) {
      profileID
      orgID
      role
    }
  }
`;

export const getProfilesByOrgAndRole = /* GraphQL */ `
  query GetProfilesByOrgAndRole(
    $orgID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProfileOrganizationV2FilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProfilesByOrgV2(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        profileID
        orgID
        organization {
          name
        }
        role
        createdAt
        updatedAt
        profile {
          alias
          createdAt
          email
          id
          l2manager
          level
          manager
          name
          learnUserId
          preferredTimezoneId
          status
          title
          updatedAt
        }
      }
      nextToken
    }
  }
`;

export const listProfilesByManager = /* GraphQL */ `
  query listProfilesByManager (
    $managerAlias: String!
    $filter: ModelProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProfilesByManager(
      manager: $managerAlias,
      status: { eq: "ACTIVE" },
      filter: $filter,
      limit: $limit,
      nextToken: $nextToken
    ) {
      items {
        id
        alias
        brStatus
        learnUserId
        calibrations(limit: $limit) {
          items {
            calibrationId
            independentCount
            reverseShadowCount
            reviewCount
            shadowCount
            status
          }
        }
        email
        level
        manager
        l2manager
        name
        status
        title
        updatedAt
      }
      nextToken
    }
  }
`;

export const getProfilesWithCalibration = /* GraphQL */ `
  query GetProfilesByOrg(
    $orgID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProfileOrganizationV2FilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProfilesByOrgV2(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        profile {
          id
          alias
          brStatus
          name
          level
          manager
          l2manager
          title
          email
          status
          learnUserId
          preferredTimezoneId
          calibrations(limit: $limit) {
            items {
              calibrationId
              independentCount
              reverseShadowCount
              reviewCount
              shadowCount
              status
            }
          }
          updatedAt
        }
      }
      nextToken
    }
  }
`;

export const getProfileCalibrations = /* GraphQL */ `
  query GetProfileCalibrations(
    $id: ID!
    $limit: Int
    $nextToken: String
    $calibrationsFilter: ModelProfileCalibrationFilterInput
  ) {
    getProfile(id: $id) {
      id
      alias
      name
      level
      br
      brit
      calibrations(filter: $calibrationsFilter, limit: $limit, nextToken: $nextToken) {
        items {
          calibratedAt
          calibrationId
          calibration {
            configType
            description
            id
            isActive
            maxShadowPoolSize
            minIndependent
            minReverseShadows
            minShepherdReviews
            minShadows
            name
            orgID
          }
          changeJustification
          independentCount
          lastModifiedBy
          reverseShadowCount
          reviewCount
          shadowCount
          status
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;

export const getProfileDetail = /* GraphQL */ `
  query GetProfileDetail($id: ID!) {
    getProfile(id: $id) {
      id
      activeOrg
      alias
      shepherds {
        items {
          shepherd {
            id
            alias
            name
            email
            level
            title
          }
          lastModifiedBy
          isOrgDefault
          createdAt
          updatedAt
        }
      }
      brStatus
      city
      email
      hireDate
      languages(limit: 1000) {
        items {
          id
          isoCode
          reading
          speaking
          writing
        }
      }
      learnUserId
      level
      manager
      l2manager
      name
      preferredTimezoneId
      orgs(limit: 1000) {
        items {
          orgID
        }
      }
      status
      title
      updatedAt
    }
  }
`;

export const getPeopleProfile = /* GraphQL */ `
  query GetPeopleProfile($alias: String!) {
    getPeopleProfile(alias: $alias) {
      alias
      brit
      isBarRaiser
    }
  }
`;

export const getCalibrationCohort = /* GraphQL */ `
  query getCalibrationCohort(
    $id: ID!
    $limit: Int
    $nextToken: String
  ) {
    getOrgLoopPSConfigurations(id: $id) {
      calibrations(filter: { status: { eq: IN_CALIBRATION } }, limit: $limit, nextToken: $nextToken) {
        items {
          profileId
        }
        nextToken
      }
    }
  }
`;

export const getProfileClassic = /* GraphQL */`
  query getProfileClassic($id: ID!) {
    getProfile(id: $id) {
      id
      activeOrg
      alias
      name
      title
      email
      level
      br
      brit
      learnUserId
      manager
      preferredTimezoneId
      calibrations {
        items {
          calibrationId
          independentCount
          reverseShadowCount
          reviewCount
          shadowCount
          status
        }
      }
      orgs {
        items {
          organization {
            name
            id
            roleLDAPGroups {
              items {
                group
                role
              }
            }
            status
          }
        }
      }
    }
  }
`;

export const getProfilePlatform = /* GraphQL */`
  query getProfilePlatform($id: ID!) {
    getProfile(id: $id) {
      id
      activeOrg
      alias
      name
      title
      email
      learnUserId
      level
      br
      brit
      manager
      preferredTimezoneId
      calibrations {
        items {
          calibrationId
          independentCount
          reverseShadowCount
          reviewCount
          shadowCount
          status
        }
      }
      orgs {
        items {
          organization {
            name
            id
            roleGroups {
              items {
                app
                teamId
                role
              }
            }
            status
          }
        }
      }
    }
  }
`;

export const listprofilesByBRStatus = /* GraphQL */`
  query listprofilesByBRStatus(
    $brStatus: BarRaiserStatus!
    $brOrgFilter: ModelProfileOrganizationV2FilterInput
    $filter: ModelProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProfilesByBrStatus(brStatus: $brStatus, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        activeOrg
        alias
        createdAt
        email
        id
        level
        manager
        name
        orgs(filter: $brOrgFilter, limit: 1000) {
          items {
            orgID
          }
        }
        preferredTimezoneId
        status
        title
        updatedAt
      }
      nextToken
    }
  }
`;

export const lookupProfileByAlias = /* GraphQL */ `
  query lookupProfileByAlias($alias: String!) {
    findProfileByAlias(alias: $alias, limit: 1) {
      items {
        id
        preferredTimezoneId
      }
    }
  }
`;
